import { IpaType } from "../phonemes/ipa";
import { Rule } from "./rule";

/** make rules that steps between phonemes in chains, forward or backward */
export function makeRules(chains: IpaType[][], forward: boolean): Rule[] {
  return chains.flatMap(chain => handleChain(chain, forward));
}

function handleChain(chain: IpaType[], forward: boolean): Rule[] {
  const rules: Rule[] = [];
  if (forward) {
    for (let i = chain.length - 2; i >= 0; i--) {
      rules.push({ from: chain[i], to: chain[i + 1] });
    }
  } else {
    for (let i = 0; i < chain.length - 1; i++) {
      rules.push({ from: chain[i + 1], to: chain[i] });
    }
  }
  return rules;
}
